<template>

  <range-date
    :value="valueRange"
    @input="setRangedate"
    style="min-width: 210px"> 
    </range-date>

</template>

<script>
import RangeDate from '@/components/Fields/RangeDate'

export default {
  name: 'RangeDateFilter',
  components: {
    RangeDate
  },
  props: {
    'value': {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valueRange () {
      return this.value ? this.value.slice(2, -1).split('|') : null
    }
  },
  created () {
  },
  methods: {
    setRangedate (date) {
      const mongoRange = date ? ('d|' + date.join('|')) : null
      this.$emit('input', mongoRange)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/RangeDateFilter.vue